import React from "react";

const Loading = props => (
  <div className="loading">
    <img
      className="loading__icon"
      src="https://images.e-auditoria.com.br/global/gif/loading.gif"
      alt="e-Recuperador"
    />
    {props.text ? <span>{props.text}</span> : null}
  </div>
);

export default Loading;
